/**
 * Supabase Client Setup — Web Version
 *
 * Auth enabled for web (anonymous + email + OAuth).
 * Used for:
 * - Cloud saves (web_save_games table)
 * - Mythic claims tracking
 * - Leaderboard reads (via Edge Functions)
 * - Future: Stripe payments, web leaderboards
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://myewadumxchzjlmygvhn.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im15ZXdhZHVteGNoempsbXlndmhuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU1OTAzNjUsImV4cCI6MjA4MTE2NjM2NX0.NpG4Q2ZhtIQ3a-nlNHdBAxIn6EcmkJIaHO3zdLUHEXg'

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  }
)
